'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Panels = require('../../main/jsx/Panels');

var _Panels2 = _interopRequireDefault(_Panels);

var _noImagePanel = require('../../../../molecules/no-image-panel');

var _noImagePanel2 = _interopRequireDefault(_noImagePanel);

var _themeManager = require('./../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

var _moleculesMap = require('./../../utilities/moleculesMap');

var _moleculesMap2 = _interopRequireDefault(_moleculesMap);

var _clone = require('../../../../../utilities/clone');

var _clone2 = _interopRequireDefault(_clone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// Organism Imports

// Molecule Imports

// Utilities Imports


var SimplePanelsStacked = function (_React$Component) {
  _inherits(SimplePanelsStacked, _React$Component);

  function SimplePanelsStacked() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SimplePanelsStacked);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimplePanelsStacked.__proto__ || Object.getPrototypeOf(SimplePanelsStacked)).call.apply(_ref, [this].concat(args))), _this), _this.renderPanels = function (items, config) {
      var type = config.type,
          theme = config.theme;

      var defaultType = type || 'NoImagePanel';
      var Panel = _moleculesMap2.default[defaultType];
      if (items) {
        return items.map(function (properties, idx) {
          var newProps = (0, _themeManager2.default)(properties, theme);
          var key = idx;
          return _react2.default.createElement(Panel, _extends({}, newProps, { name: 'SmplPnlStk', key: key }));
        });
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SimplePanelsStacked, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config;
      var items = content.items;


      return _react2.default.createElement(
        _Panels2.default,
        this.props,
        this.renderPanels(items, config)
      );
    }
  }]);

  return SimplePanelsStacked;
}(_react2.default.Component);

exports.default = SimplePanelsStacked;


SimplePanelsStacked.propTypes = _Panels2.default.propTypes;

var items = [_noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps];
SimplePanelsStacked.defaultProps = (0, _clone2.default)(_Panels2.default.defaultProps);
SimplePanelsStacked.defaultProps.content.items = items;
SimplePanelsStacked.defaultProps.config.type = 'NoImagePanel';


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/panels/simple-panels-stacked/jsx/SimplePanelsStacked.js
// module id = 1128
// module chunks = 4